var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-conversation" }, [
    _c("header", [
      _vm.conversation
        ? _c("span", { staticClass: "conversationTitle" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.conversation.fullname) +
                " " +
                _vm._s(_vm.$t("chatbotv2.withBot")) +
                "\n        "
            ),
          ])
        : _c("span", { staticClass: "conversationTitle" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.userWithBot"))),
          ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "archives-conversation" }, [
      _c(
        "div",
        {
          staticClass: "conversation",
          staticStyle: { background: "rgb(255, 255, 255)" },
        },
        [
          _vm.conversation &&
          _vm.getMessages().length &&
          _vm.conversation._id !== null
            ? _c("MessageList", {
                attrs: {
                  "always-scroll-to-bottom": false,
                  colors: _vm.colors,
                  messages: _vm.getMessages(),
                  participants: _vm.getParticipants(),
                  "scroll-top": true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }